module.exports = {
      id: "lifestyle-usage",
      viewBox: "0 0 24.217 32.155",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#lifestyle",
      toString: function () {
        return this.url;
      }
    }